export default "__VITE_ASSET__edd3d241__"